import { Spinner } from '@/components/ui/spinner';

export function AuthLoadingScreen() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-secondary px-6">
      <div className="flex flex-col items-center gap-3 text-center" role="status" aria-live="polite">
        <Spinner className="size-5" aria-hidden="true" />
        <p className="text-sm font-light text-muted-foreground">Restoring your secure session...</p>
      </div>
    </div>
  );
}
